import { Validators } from '@angular/forms';
import type {
  PathKind,
  SchemaPath,
  SchemaPathRules,
} from '@angular/forms/signals';
import { maxLength } from '@angular/forms/signals';

const ONYX_TEXTAREA_MAX_LENGTH = 65536;

export const onyxTextareaLengthValidator = Validators.maxLength(
  ONYX_TEXTAREA_MAX_LENGTH,
);

export const onyxTextareaLength = <TPathKind extends PathKind = PathKind.Root>(
  schemaPath: SchemaPath<string, SchemaPathRules.Supported, TPathKind>,
): void => maxLength(schemaPath, ONYX_TEXTAREA_MAX_LENGTH);
